module.exports = __webpack_public_path__ + "static/media/map.520e59be.jpg";